<template>
  <router-view/>
</template>

<script>
export default {
  name: 'app-router-view',
};
</script>
